/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// ============================================
// DISABLED DATES CONFIGURATION
// Easy to edit section for non-developers
// ============================================

// Single dates to disable (format: 'YYYY-MM-DD')
const DISABLED_SINGLE_DATES = [
    //'2025-07-04',  // July 4, 2025 (Thursday)
  ];
  
  // Date ranges to disable (format: {start: 'YYYY-MM-DD', end: 'YYYY-MM-DD'})
const DISABLED_DATE_RANGES = [
  {
    start: '2025-08-18',  // 18th August 2025
    end: '2025-08-19'     // 19th August 2025
  },
  {
    start: '2026-07-03',  // 3rd July 2026
    end: '2026-07-12'     // 12th July 2026
  },
  {
    start: '2026-09-11',   // 18th September 2026
    end: '2026-09-12'      // 31st September 2026
  }  

  // Add more ranges as needed, like this:
  // {
  //   start: '2025-12-24',  // Christmas Eve
  //   end: '2025-12-26'     // Boxing Day
  // }
];
  
  // ============================================
  // TECHNICAL CODE BELOW - DO NOT MODIFY
  // ============================================
  
  // Convert human-readable dates to timestamps
  function convertDatesToTimestamps() {
    const timestamps = [];
    
    // Convert single dates
    DISABLED_SINGLE_DATES.forEach(function(dateStr) {
      const date = new Date(dateStr + 'T00:00:00');
      timestamps.push(date.getTime().toString());
    });
    
    // Convert date ranges
    DISABLED_DATE_RANGES.forEach(function(range) {
      const startDate = new Date(range.start + 'T00:00:00');
      const endDate = new Date(range.end + 'T00:00:00');
      
      // Add each day in the range
      for (let currentDate = new Date(startDate); currentDate <= endDate; currentDate.setDate(currentDate.getDate() + 1)) {
        timestamps.push(currentDate.getTime().toString());
      }
    });
    
    // Remove duplicates
    return [...new Set(timestamps)];
  }
  
  // Get all disabled timestamps
  const DISABLED_TIMESTAMPS = convertDatesToTimestamps();
  
  // Check if a date should be disabled based on time restrictions
  function shouldDisableDate(timestamp) {
    const date = new Date(parseInt(timestamp));
    
    // Get current time in Eastern Time (New York timezone)
    const nowInET = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    
    // Build date object for comparison
    const todayInET = new Date(
      parseInt(nowInET.find(p => p.type === 'year').value),
      parseInt(nowInET.find(p => p.type === 'month').value) - 1, // Month is 0-indexed
      parseInt(nowInET.find(p => p.type === 'day').value)
    );
    
    const currentHourET = parseInt(nowInET.find(p => p.type === 'hour').value);
    
    // Debug logging for time checks
    if (date.toDateString() === todayInET.toDateString()) {
      console.log(`Time check: Current ET hour is ${currentHourET}:xx (${currentHourET >= 12 ? 'PAST' : 'BEFORE'} noon cutoff)`);
    }
    
    // Check if it's today and current time is 12pm or later (in Eastern Time)
    if (date.toDateString() === todayInET.toDateString()) {
      if (currentHourET >= 12) {
        return true;
      }
    }
    
    return false;
  }
  
  function disableDates() {
    // Disable predefined dates from arrays
    DISABLED_TIMESTAMPS.forEach(function(timestamp) {
      const dateElement = document.querySelector('[data-pick="' + timestamp + '"]');
      
      if (dateElement && !dateElement.classList.contains('picker__day--disabled')) {
        console.log('Disabling predefined date:', timestamp);
        dateElement.classList.add('picker__day--disabled');
        dateElement.setAttribute('aria-disabled', 'true');
        dateElement.classList.remove('picker__day--selected');
        dateElement.classList.remove('picker__list-item--highlighted-2');
        dateElement.removeAttribute('aria-selected');
        dateElement.removeAttribute('aria-activedescendant');
      }
    });
    
    // Check all available dates for today-after-noon restrictions
    const allDateElements = document.querySelectorAll('[data-pick]');
    let todayDisabledByNoon = false;
    
    allDateElements.forEach(function(dateElement) {
      const timestamp = dateElement.getAttribute('data-pick');
      
      if (shouldDisableDate(timestamp) && !dateElement.classList.contains('picker__day--disabled')) {
        const date = new Date(parseInt(timestamp));
        console.log('Disabling today (after noon ET):', date.toDateString());
        todayDisabledByNoon = true;
        
        dateElement.classList.add('picker__day--disabled');
        dateElement.setAttribute('aria-disabled', 'true');
        dateElement.classList.remove('picker__day--selected');
        dateElement.classList.remove('picker__list-item--highlighted-2');
        dateElement.removeAttribute('aria-selected');
        dateElement.removeAttribute('aria-activedescendant');
      }
    });
    
    // Log summary of what happened
    const disabledCount = document.querySelectorAll('.picker__day--disabled').length;
    const timestamp = new Date().toLocaleTimeString();
    console.log(`[${timestamp}] Date check completed. Total disabled: ${disabledCount}${todayDisabledByNoon ? ' (including today due to noon cutoff)' : ''}`);
  }
  
  // Add CSS for disabled styling
  const style = document.createElement('style');
  style.textContent = `
    .picker__day--disabled {
      color: #ddd !important;
      cursor: default !important;
      background: #f5f5f5 !important;
      pointer-events: none !important;
    }
  `;
  document.head.appendChild(style);
  
  // Watch for when the date picker gets added to the DOM
  function watchForDatePicker() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if this is the picker or contains the picker
            if (node.classList && node.classList.contains('picker')) {
              console.log('Date picker detected - running initial date check');
              setTimeout(disableDates, 100);
            }
            
            // Also check if picker was added inside this node
            const picker = node.querySelector && node.querySelector('.picker');
            if (picker) {
              console.log('Date picker found inside added node - running initial date check');
              setTimeout(disableDates, 100);
            }
            
            // Check for picker table specifically
            const pickerTable = node.querySelector && node.querySelector('.picker__table');
            if (pickerTable) {
              console.log('Picker table found - running initial date check');
              setTimeout(disableDates, 100);
            }
          }
        });
      });
    });
    
    // Watch the entire document for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  $(document).ready(function() {
    // Start watching for the date picker
    watchForDatePicker();
    
    // Also try when Zapiet events fire (if available)
    if (typeof ZapietEvent !== 'undefined') {
      ZapietEvent.listen('pickup.datepicker.rendered', function() {
        console.log('Pickup datepicker rendered event fired - running date check');
        setTimeout(disableDates, 100);
      });
      
      ZapietEvent.listen('delivery.datepicker.rendered', function() {
        console.log('Delivery datepicker rendered event fired - running date check');
        setTimeout(disableDates, 100);
      });
    }
    
    // Continuous checking: monitor for noon cutoff and picker changes
    setInterval(function() {
      if (document.querySelector('.picker__table')) {
        disableDates();
      }
    }, 60000); // Check every 60 seconds for real-time noon cutoff
  });
  

// ============================================
// SHOW MESSAGE WHEN MAXIMUM CHARACTER LIMITED REACHED ON CART CUSTOM MESSAGE TEXTAREA
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  if (document.body.id === 'your-shopping-cart') {
    document.addEventListener('input', function(e) {
      if (e.target.matches('textarea[data-cart-product-note]')) {
        const metaNoteElement = e.target.closest('.cart-item__meta-note');
        
        if (metaNoteElement) {
          if (e.target.value.length >= 150) {
            metaNoteElement.classList.add('max-character-limit-reached');
          } else {
            metaNoteElement.classList.remove('max-character-limit-reached');
          }
        }
      }
    });
  }
});

  /* ========
  re-initializing the Zapiet pickup/delivery widget when certain cart-related events occur
  ========= */
  
  $(window).on("drawer_open_done", function() {
      if (window.Zapiet && window.ZapietCachedSettings) {
        Zapiet.start(ZapietCachedSettings);
      }
   });
  
  $(window).on("cart_update_done", function() {
    if (window.Zapiet && window.ZapietCachedSettings) {
      Zapiet.start(ZapietCachedSettings);
    }
  });